export default {
  "NfdwEdu_ZenUniversity": {
    "id": 1,
    "name": "nfdw-edu/zen-university",
    "displayName": "学校法人日本財団ドワンゴ学園 ZEN大学",
    "updatedAt": "2024-10-07T00:00:00Z",
    "roles": [
      {
        "id": 1,
        "organizationId": 1,
        "name": "applicant",
        "displayName": "出願者"
      },
      {
        "id": 2,
        "organizationId": 1,
        "name": "student/regular",
        "displayName": "正科生"
      },
      {
        "id": 3,
        "organizationId": 1,
        "name": "guarantor",
        "displayName": "保証人"
      },
      {
        "id": 4,
        "organizationId": 1,
        "name": "student/credited-auditor",
        "displayName": "科目等履修生"
      },
      {
        "id": 5,
        "organizationId": 1,
        "name": "student/special-auditor",
        "displayName": "特別聴講生"
      },
      {
        "id": 6,
        "organizationId": 1,
        "name": "student/auditor",
        "displayName": "聴講生"
      },
      {
        "id": 7,
        "organizationId": 1,
        "name": "applicant/enrolled",
        "displayName": "入学確定者"
      },
      {
        "id": 8,
        "organizationId": 1,
        "name": "applicant-with-bonus",
        "displayName": "早期出願特典対象者"
      }
    ],
    "currentProfileSpec": {
      "id": 1,
      "organizationId": 1,
      "version": 1777264604,
      "fields": [
        {
          "name": "applicationNumber",
          "displayName": "出願番号",
          "type": "string",
          "required": false,
          "sensitive": false
        },
        {
          "name": "guarantorFor",
          "displayName": "出願者",
          "type": "object",
          "required": false,
          "sensitive": false
        },
        {
          "name": "studentNumber",
          "displayName": "学籍番号",
          "type": "string",
          "required": false,
          "sensitive": false
        },
        {
          "name": "department",
          "displayName": "学科",
          "type": "string",
          "required": false,
          "sensitive": false
        },
        {
          "name": "year",
          "displayName": "入学年",
          "type": "number",
          "required": false,
          "sensitive": false
        },
        {
          "name": "fullName",
          "displayName": "氏名",
          "type": "string",
          "required": false,
          "sensitive": true
        },
        {
          "name": "fullNameKana",
          "displayName": "氏名（カナ）",
          "type": "string",
          "required": false,
          "sensitive": true
        },
        {
          "name": "name",
          "displayName": "氏名",
          "type": "string",
          "required": false,
          "sensitive": true
        },
        {
          "name": "nameKana",
          "displayName": "氏名カナ",
          "type": "string",
          "required": false,
          "sensitive": true
        },
        {
          "name": "mailAddr",
          "displayName": "学生メールアドレス",
          "type": "string",
          "required": false,
          "sensitive": true
        }
      ]
    }
  },
  "NfdwEdu": {
    "id": 2,
    "name": "nfdw-edu",
    "displayName": "学校法人日本財団ドワンゴ学園",
    "updatedAt": "2025-01-08T00:00:00Z",
    "roles": [
      {
        "id": 200,
        "organizationId": 2,
        "name": "staff",
        "displayName": "教職員"
      },
      {
        "id": 201,
        "organizationId": 2,
        "name": "admin",
        "displayName": "管理者"
      },
      {
        "id": 202,
        "organizationId": 2,
        "name": "console-operator/admin",
        "displayName": "Console管理者"
      },
      {
        "id": 203,
        "organizationId": 2,
        "name": "console-operator/editor",
        "displayName": "Console編集者"
      },
      {
        "id": 204,
        "organizationId": 2,
        "name": "console-operator/viewer",
        "displayName": "Console閲覧者"
      },
      {
        "id": 205,
        "organizationId": 2,
        "name": "faculty",
        "displayName": "教員"
      }
    ],
    "currentProfileSpec": {
      "id": 2,
      "organizationId": 2,
      "version": 1786071007,
      "fields": [
        {
          "name": "name",
          "displayName": "氏名",
          "type": "string",
          "required": false,
          "sensitive": true
        },
        {
          "name": "nameKana",
          "displayName": "氏名カナ",
          "type": "string",
          "required": false,
          "sensitive": true
        }
      ]
    }
  },
  "KadokawaGroup_Dwango": {
    "id": 3,
    "name": "kadokawa-group/dwango",
    "displayName": "株式会社ドワンゴ",
    "updatedAt": "2025-01-08T00:00:00Z",
    "roles": [
      {
        "id": 300,
        "organizationId": 3,
        "name": "staff/contents-development",
        "displayName": "コンテンツ開発部社員"
      },
      {
        "id": 301,
        "organizationId": 3,
        "name": "staff/service-development",
        "displayName": "サービス開発部社員"
      },
      {
        "id": 302,
        "organizationId": 3,
        "name": "staff/dsms-development",
        "displayName": "成績システム開発チーム"
      }
    ],
    "currentProfileSpec": {}
  },
  "KddwEdu_NHighschool": {
    "id": 4,
    "name": "kddw-edu/n-highschool",
    "displayName": "学校法人角川ドワンゴ学園 N高等学校",
    "updatedAt": "2026-06-01T00:00:00Z",
    "roles": [
      {
        "id": 400,
        "organizationId": 4,
        "name": "student/regular-course",
        "displayName": "普通科生徒"
      },
      {
        "id": 401,
        "organizationId": 4,
        "name": "student/regular-course-basic",
        "displayName": "普通科ベーシック生徒"
      }
    ],
    "currentProfileSpec": {
      "id": 4,
      "organizationId": 4,
      "version": 1780239600,
      "fields": [
        {
          "name": "studentNumber",
          "displayName": "学籍番号",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "term",
          "displayName": "所属期",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "studentType",
          "displayName": "在籍種別",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "grade",
          "displayName": "学年",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "entranceDate",
          "displayName": "入学予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "graduateScheduleDate",
          "displayName": "卒業予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "schoolEmail",
          "displayName": "高校メールアドレス",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "version",
          "displayName": "バージョン",
          "type": "number",
          "required": false,
          "sensitive": false
        }
      ]
    }
  },
  "KddwEdu_SHighschool": {
    "id": 5,
    "name": "kddw-edu/s-highschool",
    "displayName": "学校法人角川ドワンゴ学園 S高等学校",
    "updatedAt": "2026-06-01T00:00:00Z",
    "roles": [
      {
        "id": 500,
        "organizationId": 5,
        "name": "student/regular-course",
        "displayName": "普通科生徒"
      },
      {
        "id": 501,
        "organizationId": 5,
        "name": "student/regular-course-basic",
        "displayName": "普通科ベーシック生徒"
      }
    ],
    "currentProfileSpec": {
      "id": 5,
      "organizationId": 5,
      "version": 1780239600,
      "fields": [
        {
          "name": "studentNumber",
          "displayName": "学籍番号",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "term",
          "displayName": "所属期",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "studentType",
          "displayName": "在籍種別",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "grade",
          "displayName": "学年",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "entranceDate",
          "displayName": "入学予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "graduateScheduleDate",
          "displayName": "卒業予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "schoolEmail",
          "displayName": "高校メールアドレス",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "version",
          "displayName": "バージョン",
          "type": "number",
          "required": false,
          "sensitive": false
        }
      ]
    }
  },
  "KddwEdu_RHighschool": {
    "id": 6,
    "name": "kddw-edu/r-highschool",
    "displayName": "学校法人角川ドワンゴ学園 R高等学校",
    "updatedAt": "2026-06-01T00:00:00Z",
    "roles": [
      {
        "id": 600,
        "organizationId": 6,
        "name": "student/regular-course",
        "displayName": "普通科生徒"
      },
      {
        "id": 601,
        "organizationId": 6,
        "name": "student/regular-course-basic",
        "displayName": "普通科ベーシック生徒"
      }
    ],
    "currentProfileSpec": {
      "id": 6,
      "organizationId": 6,
      "version": 1780239600,
      "fields": [
        {
          "name": "studentNumber",
          "displayName": "学籍番号",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "term",
          "displayName": "所属期",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "studentType",
          "displayName": "在籍種別",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "grade",
          "displayName": "学年",
          "type": "number",
          "required": true,
          "sensitive": false
        },
        {
          "name": "entranceDate",
          "displayName": "入学予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "graduateScheduleDate",
          "displayName": "卒業予定年月日",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "schoolEmail",
          "displayName": "高校メールアドレス",
          "type": "string",
          "required": true,
          "sensitive": false
        },
        {
          "name": "version",
          "displayName": "バージョン",
          "type": "number",
          "required": false,
          "sensitive": false
        }
      ]
    }
  },
  "CustomerService": {
    "id": 9,
    "name": "customer-service",
    "displayName": "ZEN ID カスタマーサービス",
    "updatedAt": "2025-12-15T00:00:00Z",
    "roles": [
      {
        "id": 901,
        "organizationId": 9,
        "name": "console-operator/admin",
        "displayName": "Console管理者"
      },
      {
        "id": 902,
        "organizationId": 9,
        "name": "console-operator/editor",
        "displayName": "Console編集者"
      },
      {
        "id": 903,
        "organizationId": 9,
        "name": "console-operator/viewer",
        "displayName": "Console閲覧者"
      },
      {
        "id": 909,
        "organizationId": 9,
        "name": "console-operator/viewer/temporary",
        "displayName": "Console閲覧者(期間限定)"
      }
    ],
    "currentProfileSpec": {}
  }
} as const;
